import React, { useState, useRef, useEffect } from 'react';

import { Info, X, Bold, Italic, List, Link } from 'lucide-react';



export const InfoTooltip = ({ text }) => {
    const [isVisible, setIsVisible] = useState(false);
  
    return (
      <div className="relative inline-block">
        <button
          type="button"
          className="text-gray-400 hover:text-gray-600 transition-colors"
          onMouseEnter={() => setIsVisible(true)}
          onMouseLeave={() => setIsVisible(false)}
          onClick={(e) => {
            e.preventDefault();
            setIsVisible(!isVisible);
          }}
        >
          <Info className="w-4 h-4" />
        </button>
        
        {isVisible && (
          <div 
            className="absolute z-50 w-64 p-2 mt-2 text-sm text-gray-600 bg-white rounded-lg shadow-lg border border-gray-200 -translate-x-1/2 left-1/2 animate-in fade-in slide-in-from-top-1 duration-200"
          >
            {text}
            <div className="absolute -top-2 left-1/2 -translate-x-1/2 w-2 h-2 bg-white rotate-45 border-l border-t border-gray-200"/>
          </div>
        )}
      </div>
    );
  };

  